var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconSelectDown = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.007,
    height: 9.711,
    viewBox: "0 0 18.007 9.711",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6863",
    "data-name": "Path 6863",
    d: "M1161.021,301.317l8.65,8.65,8.65-8.65",
    transform: "translate(-1160.668 -300.964)",
    fill: "none",
    stroke: "#929292",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconSelectDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-select-down.58e05d55.svg";
export { ForwardRef as ReactComponent };